import { defineRoutes } from '../utils';

const BASE = '/more';

/**
 * "More" (formerly "Settings") domain routes — profile, users, contacts,
 * customers, saved locations, and the carrier-only pricing/places pages.
 * Mounted under `/more` in both customer-dashboard and carrier-dashboard.
 * Legacy `/settings/*` paths are kept as redirects in each app's router
 * for backward compatibility with bookmarked URLs.
 */
export const settingsRoutes = defineRoutes({
  settings: {
    path: BASE,
    isPublic: false,
  },
  /**
   * Org profile screen. Always renders the current user's own org —
   * the underlying page reads `useCurrentUser()` for the org id, so
   * no `:id` path segment is needed (and including one would just
   * encourage callers to leak the user id into URLs).
   *
   * Optional `tab` search param drives the active section
   * (`general` / `legal` / `banking`) so deep links from financing
   * / sidebar CTAs can land directly on the right tab — e.g.
   * `route('settings_profile', { tab: 'banking' })` → `/more/profile?tab=banking`.
   */
  settings_profile: {
    path: `${BASE}/profile`,
    isPublic: false,
    params: {} as {
      tab?: 'general' | 'legal' | 'banking';
    },
  },
  settings_users: {
    path: `${BASE}/users`,
    isPublic: false,
  },
  settings_contacts: {
    path: `${BASE}/contacts`,
    isPublic: false,
  },
  /** Carrier-only standalone pricing surface (mounted under /more/pricing). */
  settings_pricing: {
    path: `${BASE}/pricing`,
    isPublic: false,
  },
  /** Carrier-only standalone places surface (mounted under /more/places). */
  settings_places: {
    path: `${BASE}/places`,
    isPublic: false,
  },
  /** Apps & integrations marketplace (mounted under /more/apps). */
  settings_apps: {
    path: `${BASE}/apps`,
    isPublic: false,
  },
  customers: {
    path: '/customers',
    isPublic: false,
  },
  saved_locations: {
    path: '/saved-locations',
    isPublic: false,
  },
});
